import * as React from 'react';
import { IWidget } from 'common/schema/widget/Widget';
import { Form, Input } from 'antd';
import { WidgetDynamicViewType } from 'common/schema/widget/dynamic/WidgetDynamic';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import { DynamicComputeMetadataProcessor } from 'common/schema/metadata/DynamicComputeMetadataProcessor';

export interface IFormWidgetDynamicComputedFieldViewProps {
  widget: IWidget;
}

export function FormWidgetDynamicComputedFieldView(
  props: IFormWidgetDynamicComputedFieldViewProps
) {
  const { widget } = props;

  const { procedure, request, requestPreview } = useRequestCompileContext();
  const value = DynamicComputeMetadataProcessor.compileWidget(
    procedure,
    requestPreview,
    widget
  );

  if (widget.dynamic!.view === WidgetDynamicViewType.None) return null;

  return (
    <Form.Item label={widget.dynamic?.label}>
      {widget.dynamic!.view === WidgetDynamicViewType.Text && (
        <span>{value}</span>
      )}
      {widget.dynamic!.view === WidgetDynamicViewType.TextField && (
        <Input disabled value={value} />
      )}
    </Form.Item>
  );
}
